import React, {useState} from 'react';
import {Box, Typography, Tabs, Tab} from '@mui/material';
import PartnerDashboardShell from '../components/PartnerDashboard.comp';
import PackageUptakeTab from '../tabs/PackageUptake.tab';
import ModuleUsageTab from '../tabs/ModuleUsage.tab';

const NAVY   = '#052F44';
const ORANGE = '#FF6900';
const TEAL   = '#1B6B55';

/* ── Per-tab metadata ───────────────────────────────────────────── */
const TAB_LABELS    = ['Package Uptake', 'Module Usage'];
const TAB_SUBTITLES = [
    'Which products or packages are being used, and where?',
    'Which modules are being used and completed?',
];

/* ── Main page ──────────────────────────────────────────────────── */
const ProductsPage = () => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <PartnerDashboardShell
            tabs={
                <Tabs
                    value={activeTab}
                    onChange={(_, v) => setActiveTab(v)}
                    TabIndicatorProps={{style: {backgroundColor: ORANGE}}}
                    sx={{
                        borderBottom: '1px solid #E5E7EB',
                        mb: 1,
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '14px',
                            color: '#6A7282',
                            px: 2,
                        },
                        '& .Mui-selected': {color: `${ORANGE} !important`},
                    }}
                >
                    <Tab label="Package Uptake"/>
                    <Tab label="Module Usage"/>
                </Tabs>
            }
        >
            {/* Title */}
            <Typography sx={{fontSize: '23px', fontWeight: 800, color: NAVY, mb: 0.5, mt: 1.5}}>
                {activeTab === 1 ? 'Module Usage' : 'Product / Package Uptake'}
            </Typography>

            {/* Subtitle */}
            <Box sx={{mb: 3}}>
                <Typography sx={{fontSize: '14px', fontStyle: 'italic', color: '#4B5563'}}>
                    {TAB_SUBTITLES[activeTab]}
                </Typography>
            </Box>

            {activeTab === 0 && <PackageUptakeTab/>}
            {activeTab === 1 && <ModuleUsageTab/>}

        </PartnerDashboardShell>
    );
};

export default ProductsPage;
